// A tortoise, modelled facing +X: a high domed shell with scute facets, a
// wrinkled head poking out and stumpy legs. Ported 1:1 from age-of-mcp's classic
// tortoise.ts, restoring its shell/head core and the stumpy-leg loop.
import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

function partsFor(): Part[] {
  const parts: Part[] = [
    { geometry: new THREE.IcosahedronGeometry(0.03, 0), color: "#6e5a32",
      position: [0, 0.026, 0], scale: [1.3, 0.85, 1.1] },            // shell dome
    { geometry: new THREE.IcosahedronGeometry(0.02, 0), color: "#8a7240",
      position: [0, 0.026, 0], scale: [1.5, 0.6, 1.25] },            // shell rim
    { geometry: new THREE.IcosahedronGeometry(0.013, 0), color: "#9a8458",
      position: [0.04, 0.018, 0], scale: [1.4, 0.9, 0.9] },          // head
  ];
  for (const [x, z] of [[0.022, 0.024], [0.022, -0.024], [-0.022, 0.024], [-0.022, -0.024]]) {
    parts.push({ geometry: new THREE.CylinderGeometry(0.006, 0.006, 0.026, 4),
      color: "#7a6644", position: [x!, 0.013, z!] });
  }
  return parts;
}

export const tortoise = defineModel({
  id: "tortoise",
  batchId: "standard",
  name: "Tortoise",
  tags: ["creature","tortoise","low-poly","age-of-mcp","classic"],
  summary: "Low-poly tortoise.",
  description: "Ported from the age-of-mcp gallery.",
  author: "age-of-mcp",
  footprint: 0.08,
  parts: () => partsFor(),
  animations: [],
});
